import Button, { ButtonModel } from '@src/components/button/Button';
import Svg from '@src/components/svg/Svg';
import { BasedModel, getModifiers } from '@src/helpers/getModifiers';

export interface MiniCartThankYouMessageModel extends BasedModel {
  title?: string;
  description?: string;
  cartButton?: ButtonModel;
  checkoutButton?: ButtonModel;
}

const MiniCartThankYouMessage = (model: MiniCartThankYouMessageModel) => {
  const styleModifiers = getModifiers(model, 'fm-o-mini-cart-thank-you-message');
  const { title, description, cartButton, checkoutButton } = model;

  return (
    <div className={styleModifiers}>
      <div className="fm-o-mini-cart-thank-you-message__inner">
        <div className="fm-o-mini-cart-thank-you-message__icon">
          <Svg iconPath="#tick" viewBoxWidth={99} viewBoxHeight={77} />
        </div>

        {title && <div className="fm-o-mini-cart-thank-you-message__title">{title}</div>}

        {description && <div className="fm-o-mini-cart-thank-you-message__description" dangerouslySetInnerHTML={{ __html: description }}></div>}
      </div>

      <div className="fm-o-mini-cart-thank-you-message__cta">
        {cartButton && <Button {...cartButton} />}

        {checkoutButton && <Button {...checkoutButton} />}
      </div>
    </div>
  );
};

export default MiniCartThankYouMessage;
